'use strict';

export default class OPLFederatedSearch {
    constructor() {
        this.groups = [];
        this.countsAdded = false;
        this.azureSearchObj = {
            sirsi: null,
            comminico: null,
            hip: null,
            opl: null
        };
    }

    handleGroupsClickEvent(e, _indexUiKey_targetGroup) {

        if (!_indexUiKey_targetGroup || typeof _indexUiKey_targetGroup !== 'string')
            return;

        const self = window.OPL.FederatedSearch;
        const tab_targetGroup = e.currentTarget;
        // is the current group active?
        const isActive = tab_targetGroup.classList.contains('active');

        // if the current group is not active
        // then lets switch the current group
        if (!isActive) {
            self.changeActiveGroup(_indexUiKey_targetGroup)
        }
    }

    handleGroupsChangeEvent(e) {
        const self = window.OPL.FederatedSearch;

        if (e.currentTarget.value) {
            self.changeActiveGroup(e.currentTarget.value);
        }
    }

    // change the current group
    changeActiveGroup(_indexUiKey_targetGroup) {
        const self = window.OPL.FederatedSearch;

        // lets get the actual active tab
        const tab_activeGroup = document.querySelector('.opl-federated-search-main-sidebar-nav-list-item.active');
        // get the wrapper of the target group
        const resultsWrapper_targetGroup = document.querySelector(`#federated-search-group-wrapper-${_indexUiKey_targetGroup}`);
        // get the tab of the target group
        const tab_targetGroup = document.querySelector(`.opl-federated-search-main-sidebar-nav-list-item[data-index-ui-key='${_indexUiKey_targetGroup}']`);
        // get the mobile group selector
        const groupSelector = document.querySelector(`#opl-federated-search-mobile-nav`);

        if (tab_activeGroup && tab_targetGroup && resultsWrapper_targetGroup) {

            // get the "index UI Key" from the button's dataset
            const indexUiKey_activeGroup = tab_activeGroup.dataset["indexUiKey"];
            // get the results wrapper container, to show/hide
            const resultsWrapper_activeGroup = document.querySelector(`#federated-search-group-wrapper-${indexUiKey_activeGroup}`);
            // get the results listing wrapper container, to clear/re-render the listing
            const resultsList_activeGroup = document.querySelector(`#federated-search-results-${indexUiKey_activeGroup}`);
            // get the results message container, to clear/re-render the message
            const resultsMsgContainer_activeGroup = document.querySelector(`#federated-search-msg-${indexUiKey_activeGroup}`);
            // get the results pagination wrapper, to clear/re-render the pagination
            const paginationWrapper_activeGroup = document.querySelector(`#federated-search-pager-${indexUiKey_activeGroup}`);
            // get the results sort element, to reset it
            const sortSelect_activeGroup = document.querySelector(`#federated-search-sort-${indexUiKey_activeGroup}`);
            // get the results facaets wrapper, if it exists
            // for both the target and active group
            const facetsWrapper_activeGroup = document.querySelector(`#federated-search-offcanvas-${indexUiKey_activeGroup}`);
            const selectedFacetsWrapper_activeGroup = document.querySelector(`#federated-search-active-facets-${indexUiKey_activeGroup}`);
            const facetsWrapper_targetGroup = document.querySelector(`#federated-search-offcanvas-${_indexUiKey_targetGroup}`);

            // get the 'upcoming' quick filter
            // so that we can trigger the click
            // and reset the date filters
            const upcomingCTA_activeGroup = document.querySelector(`#federated-search-today-${indexUiKey_activeGroup}`)

            // if the "active" group container exists
            if (resultsWrapper_activeGroup) {

                // FIRST, Hide the active group results container
                resultsWrapper_activeGroup.classList.remove('active');
                tab_activeGroup.classList.remove('active');
                // if the facet wrapper exists, hide it
                if (facetsWrapper_activeGroup) {
                    facetsWrapper_activeGroup.classList.remove('active');
                    if (upcomingCTA_activeGroup) {
                        window.OPL.AzureSearch.triggerDateChange = false;
                        window.OPL.AzureSearch.setDate(`#federated-search-upcoming-${indexUiKey_activeGroup}`, 'upcoming');
                        window.OPL.AzureSearch.triggerDateChange = true;
                    }
                }

                // if there is no search term,
                // we dont need to clear the results

                if (window.OPL.AzureSearch.searchTerm !== '' && window.OPL.AzureSearch.searchTerm !== null && typeof window.OPL.AzureSearch.searchTerm !== 'undefined') {

                    // reset the active group the sort dropdown
                    sortSelect_activeGroup.selectedIndex = 0;

                    // THEN, we will reset the content inside
                    // empty the active group results container
                    if (resultsWrapper_activeGroup) {
                        resultsList_activeGroup.innerHTML = "";
                    }
                    // empty the active group the pagination container
                    if (paginationWrapper_activeGroup) {
                        paginationWrapper_activeGroup.innerHTML = "";
                    }
                    // empty the active group the pagination container
                    if (resultsMsgContainer_activeGroup) {
                        resultsMsgContainer_activeGroup.innerHTML = "";
                    }
                    // empty the selected facets container
                    if (selectedFacetsWrapper_activeGroup) {
                        selectedFacetsWrapper_activeGroup.innerHTML = "";
                    }

                }

                // THEN, we will "activate" the selected tab
                resultsWrapper_targetGroup.classList.add('active');
                tab_targetGroup.classList.add('active');
                /// if the facet wrapper exists, show it
                if (facetsWrapper_targetGroup) {
                    facetsWrapper_targetGroup.classList.add('active');
                }

                if (groupSelector) {
                    groupSelector.value = _indexUiKey_targetGroup;
                }

                // check if we have a search term
                if (window.OPL.AzureSearch.searchTerm !== '' && window.OPL.AzureSearch.searchTerm !== null && typeof window.OPL.AzureSearch.searchTerm !== 'undefined') {
                    // And After we will fetch the search results for the selected tab
                    self.getSearchResults(_indexUiKey_targetGroup);
                }
            }
        }
    }

    // get the search results for each group
    getSearchResults(_indexUiKey) {
        if (!_indexUiKey)
            return;

        // Please do not remove the comment below because Webpack needs the chunk name to dynamically load this library.
        import(/* webpackChunkName: "TPSAzureSearch" */ '../../tps-azuresearch/dist/index').then(module => {
            const TPSAzureSearch = module.default;

            const self = window.OPL.FederatedSearch;

            const baseProps = {
                facetsSelected: [],
                dates: {
                    hasDates: false
                }
            };
            const searchProps = window[`OplSearchOptions_${_indexUiKey}`];

            // cancel the function if searchprops
            // doesnt exist, or is not an object
            if (!searchProps || typeof searchProps !== 'object')
                return;

            // create a new instance of the searchprops,
            // so as the objects are passed around as variables
            // they don't get mixed up
            const mergedProps = Object.assign({}, baseProps, searchProps);

            if (mergedProps && typeof mergedProps === 'object') {

                // now we will get the page size, b.c it could be different
                // depending on the devince (mobile vs. desktop)
                const pageSize = window.OPL.AzureSearch.getPageSize(`#federated-search-pagesize-${_indexUiKey}`);
                mergedProps.results.pager.pageSize = pageSize;

                // reset selected facets
                searchProps.facetsSelected = [];

                // call the azure search library
                // with the props
                this.azureSearchObj[_indexUiKey] = new TPSAzureSearch(mergedProps);
                this.azureSearchObj[_indexUiKey].search();
            }

            if (!self.countsAdded) {
                self.getGroupCounts();
            }

            window.OPL.AzureSearch.setupViewToggles();
        });
    }

    // Set Groups Counter
    getGroupCounts() {
        const self = window.OPL.FederatedSearch;

        import(/* webpackChunkName: "TPSAzureSearch" */ '../../tps-azuresearch/dist/index').then(module => {
            const TPSAzureSearch = module.default;

            const searchInput = document.querySelector(`#tps-azure-search-keyword-search`);

            const baseRequestBody = {
                scoringProfile: 'title',
                facets: [],
                count: true,
                skip: 0,
                queryType: 'full',
                speller: 'lexicon',
                queryLanguage: 'en-us',
                searchMode: 'any',
                search: null
            };

            self.groups.forEach((group) => {

                let searchTerm = null;
                if (searchInput) {

                    // we will generete the search term using
                    // a public function from the azure search library
                    searchTerm = TPSAzureSearch.sanitizeSearchTerm(searchInput.value, group.azureOpts, group.queryType);
                }

                let groupFilter = group.filter;

                if (group.dateFields) {
                    let date_f = '';

                    let fromDateValue, toDateValue;
                    const fromDateField = document.querySelector(group.dateFields.from.inputSelector);
                    const toDateField = document.querySelector(group.dateFields.to.inputSelector);

                    const converter = (str) => {
                        const dateParts = str.split('/');
                        const dateYear = parseInt(dateParts[2]);
                        const dateMonth = parseInt(dateParts[1]) - 1;
                        const dateDay = parseInt(dateParts[0]);

                        return new Date(dateYear, dateMonth, dateDay, 0, 0, 0, 0);
                    };

                    // handle the "from" date filter value
                    if (fromDateField) {
                        fromDateValue = TPSAzureSearch.setDateFilter(fromDateField.value, 'fromDate', converter);

                        if (fromDateValue) {
                            date_f = group.dateFields.from.indexFieldName + ' ge ' + fromDateValue.toISOString();
                        }
                    }
                    // handle the "to" date filter value
                    if (toDateField) {
                        toDateValue = TPSAzureSearch.setDateFilter(toDateField.value, 'toDate', converter);
                        if (toDateValue) {
                            if (fromDateValue)
                                date_f += ' and ';
                            date_f += group.dateFields.to.indexFieldName + ' le ' + toDateValue.toISOString();
                        }
                    }

                    if (groupFilter && date_f) {
                        groupFilter += ` and ${date_f}`;
                    } else if (date_f) {
                        groupFilter = date_f;
                    }

                }

                const groupBodyProps = {
                    filter: groupFilter,
                    search: searchTerm
                };

                const requestBody = Object.assign({}, baseRequestBody, groupBodyProps);

                const request = fetch(
                    group.requestUrl,
                    {
                        "method": "POST",
                        "headers": {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                            "api-key": group.accessKey,
                            "Cache-Control": "no-cache"
                        },
                        "body": JSON.stringify(requestBody)
                    }
                );
                // make the request
                request.then((response) => {


                    response.json().then((data) => {
                        var count = 0;
                        if (!data.error) {
                            count = data['@odata.count'];
                        }
                        self.updateGroupCtaCount(group.uiKey, count);
                        self.updateGroupSelectOptionCount(group.uiKey, count);
                    });
                });

            });

            self.countsAdded = true;

        });
    }

    // add the total results to the CTA label
    updateGroupCtaCount(_uiKey, _count) {

        const groupCtaCount = document.querySelector(`#opl-federated-search-results-nav-count-${_uiKey}`);

        if (groupCtaCount) {
            groupCtaCount.textContent = `(${_count})`;
        }

    }

    // add the total results to the dropdown option label
    updateGroupSelectOptionCount(_uiKey, _count) {
        const groupSelectOption = document.querySelector(`#opl-federated-search-mobile-nav option[value="${_uiKey}"]`);

        if (groupSelectOption) {
            const currentLabel = groupSelectOption.label;
            groupSelectOption.label = `${currentLabel} (${_count})`;
        }

    }
}
